export default __webpack_public_path__ + "static/media/baetho_Logo copy@2x.729ce4a2.png";